import React, { useCallback, useContext } from 'react';
import Button from '@material-ui/core/Button';

import fetch from 'utils/fetch';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { useHistory } from 'react-router';

async function removeFromFavourite(id: string) {
  try {
    await fetch(`/api/favourite/${id}/remove-favourite`, {
      method: 'DELETE',
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });

    return {
      ok: true,
      data: {},
    };
  } catch (e) {
    return {
      ok: false,
      data: e,
    };
  }
}

export function RemoveFavouriteDetailCell({
  data,
  allData,
}: {
  data: string;
  allData: any;
}) {
  const { go } = useHistory();
  const { showNotification } = useContext(NotificationCtx);

  const handleClick = useCallback(async () => {
    const response = await removeFromFavourite(data);

    if (response.ok) {
      showNotification(
        'Entita byla úspěšně odebrána z oblíbených.',
        NotificationVariant.SUCCESS
      );

      // refresh
      go(0);
    } else {
      showNotification(
        'Při odebíraní entity z oblíbených nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [data, go, showNotification]);

  return (
    <Button color="primary" variant="contained" onClick={handleClick}>
      Odebrat
    </Button>
  );
}
